import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { fixedSectionClass } from '../../../../../../ReactSharedScripts/utils/const';
import CustomScrollBar from '../../../../../../ReactSharedScripts/components/CustomScrollBar';
import { ErrorBoundary } from '../../../../../../ReactSharedScripts/components/ErrorBoundary';
import classes from '../../styles/index.module.scss';

type ContentProps = {
	className?: string;
	innerContentClassName?: string;
	noPadding?: boolean;
	hasCenteredInnerContent?: boolean;
	useContentHeight?: boolean;
	ref?: React.Ref<HTMLDivElement>;
	theme?: 'WHITE' | 'GRAY';
	contentPadding?: 'small' | 'normal';
};

export enum ModalBoxContentThemes {
	White = 'WHITE',
	Grey = 'GRAY',
}

export const Content: React.FC<React.PropsWithChildren<ContentProps>> = forwardRef(
	(
		{
			children,
			className,
			innerContentClassName,
			hasCenteredInnerContent = false,
			useContentHeight = false,
			contentPadding = 'normal',
			theme = ModalBoxContentThemes.White,
		},
		ref,
	) => {
		const componentClasses = classNames(className, classes.content, fixedSectionClass, {
			[classes.content__paddingNormal]: contentPadding === 'normal',
			[classes.content__paddingSmall]: contentPadding === 'small',
			[classes.content_contentHeight]: useContentHeight,
			[classes.content_white]: theme === ModalBoxContentThemes.White,
			[classes.content_grey]: theme === ModalBoxContentThemes.Grey,
		});

		const innerContentClasses = classNames(innerContentClassName, {
			[classes.centeredInnerContent]: hasCenteredInnerContent,
		});

		return (
			<ErrorBoundary>
				<CustomScrollBar className={componentClasses}>
					<div
						ref={ref}
						className={innerContentClasses}
					>
						{children}
					</div>
				</CustomScrollBar>
			</ErrorBoundary>
		);
	},
);
